import React, {useEffect, useState} from 'react'
import {inject, observer} from 'mobx-react'
import {getWarningList} from '@apis'
import ChartBlock from '@components/chartBlock'
import DeviceWarningInfoItem from '@components/device-warning-info-item'

const DeviceWarningInfomation = inject('store')(
  observer(({store}) => {
    const {userInfo = {}} = store
    const {strongProjectId: projectId} = userInfo
    const [warningList, setWarningList] = useState([])

    async function queryWarningList() {
      const params = {
        projectId,
        pageNo: 1,
        pageSize: 9999
      }
      const res = await getWarningList(params)
      if (res && res.data) {
        setWarningList(res.data)
      }
    }

    useEffect(() => {
      queryWarningList()
    }, [])

    return (
      <ChartBlock
        title="配电柜报警信息"
      >
        {
          warningList.map(item => (
            <DeviceWarningInfoItem
              warningInfo={item}
            />
          ))
        }
      </ChartBlock>
    )
  })
)

export default DeviceWarningInfomation
